import { DomainSerializer } from "src/app/global/serializables/domain.serializer";
import { AuditoriaTransferenciaCliente } from "../domain/auditoria-transferencia-cliente.model";

export class AuditoriaTransferenciaClienteSerializer extends DomainSerializer<AuditoriaTransferenciaCliente> { }